import { contentType } from '../../../utils/ActionTypes';
import { createReducerWraper } from '../../../utils/Reducer';

export const customerReducer = createReducerWraper(contentType.CUSTOMER);
export const customerTotalSPentReducer = createReducerWraper(contentType.CUSTOMER_TOTAL_SPENT);
export const customerProductGroupReducer = createReducerWraper(contentType.CUSTOMER_PRODUCT_GROUP_LIST);
